import { ColGroupDef } from '@ag-grid-community/core';
import {
  AgGridHelperService,
  ProductColGroupId,
} from '@products/fund-listing/services/ag-grid-helper.service';
import { TranslateService } from '@shared/translate/translate.service';
import { SuppressDetails } from '@types';
import { SimilarProductController } from '../controllers';

export function getSimilarProductColumnDefsForUS(
  listingController: SimilarProductController,
  suppressDetails: SuppressDetails,
  agGridHelperService: AgGridHelperService,
  translateService: TranslateService
): ColGroupDef[] {
  const colGroupDefs: ColGroupDef[] = [
    {
      groupId: ProductColGroupId.FUND,
      children: [
        agGridHelperService.getFundNameColDef(false),
        agGridHelperService.getCurrencyColDef({ width: 80 }),
        agGridHelperService.getMorningStarOverallRatingColDef(
          listingController,
          {
            headerName: translateService.instant(
              'products.morningstar-colhead'
            ),
            cellStyle: {
              background: 'rgba(0, 0, 0,0)',
            },
            maxWidth: 110,
            headerComponentParams: {
              tooltipContent: translateService.instant(
                'products.similar-product-rating-tooltip'
              ),
            },
          }
        ),
      ],
    },
    {
      groupId: ProductColGroupId.PERFORMANCE,
      headerValueGetter: () =>
        `${translateService.instant(
          'pds.PERF_AS_OF_DATE'
        )} ${listingController.getPerformanceAsOf()}`,
      headerGroupComponent: 'similarProductGroupHeaderComponent',
      headerGroupComponentParams: listingController,
      children: [
        agGridHelperService.getAvgAnnualMonthly1YrColDef(
          listingController,
          suppressDetails,
          {
            width: 80,
          }
        ),
        agGridHelperService.getAvgAnnualMonthly2YrColDef(listingController, {
          width: 80,
        }),
        agGridHelperService.getAvgAnnualMonthly3YrColDef(listingController, {
          width: 80,
        }),
        agGridHelperService.getAvgAnnualMonthly5YrColDef(listingController, {
          width: 80,
        }),
        agGridHelperService.getAvgAnnualMonthlyInceptionColDef(
          listingController,
          suppressDetails,
          {
            width: 80,
          }
        ),
      ],
    },
  ];
  return colGroupDefs;
}

export function getSimilarProductColumnDefsForIntl(
  listingController: SimilarProductController,
  suppressDetails: SuppressDetails,
  agGridHelperService: AgGridHelperService,
  translateService: TranslateService
): ColGroupDef[] {
  const colGroupDefs: ColGroupDef[] = [
    {
      groupId: 'FUND',
      children: [
        agGridHelperService.getFundNameColDef(false),
        agGridHelperService.getCurrencyColDef({ width: 80 }),
        agGridHelperService.getMorningStarOverallRatingColDef(
          listingController,
          {
            headerName: translateService.instant(
              'products.morningstar-colhead'
            ),
            cellStyle: {
              background: 'rgba(0, 0, 0,0)',
            },
            maxWidth: 110,
            headerComponentParams: {
              tooltipContent: translateService.instant(
                'products.similar-product-rating-tooltip'
              ),
            },
          }
        ),
        ,
      ],
    },
    {
      groupId: 'PERFORMANCE',
      headerValueGetter: () =>
        `${translateService.instant(
          'pds.PERF_AS_OF_DATE'
        )} ${listingController.getPerformanceAsOf()}`,
      headerGroupComponent: 'similarProductGroupHeaderComponent',
      headerGroupComponentParams: listingController,
      children: [
        agGridHelperService.getCumulativeMonthly1YrColDef(
          listingController,
          suppressDetails,
          { width: 100 }
        ),
        agGridHelperService.getCumulativeMonthly2YrColDef(listingController, {
          width: 100,
        }),
        agGridHelperService.getCumulativeMonthly3YrColDef(listingController, {
          width: 100,
        }),
        agGridHelperService.getCumulativeMonthly5YrColDef(listingController, {
          width: 100,
        }),
        agGridHelperService.getCumulativeMonthlyInceptionColDef(
          listingController,
          suppressDetails,
          {
            width: 115,
          }
        ),
        agGridHelperService.getDiscreteMonthly1YrColDef(
          listingController,
          suppressDetails,
          {
            width: 105,
          }
        ),
        agGridHelperService.getDiscreteMonthly2YrColDef(listingController, {
          width: 100,
        }),
        agGridHelperService.getDiscreteMonthly3YrColDef(listingController, {
          width: 100,
        }),
        agGridHelperService.getDiscreteMonthly4YrColDef(listingController, {
          width: 100,
        }),
        agGridHelperService.getDiscreteMonthly5YrColDef(listingController, {
          width: 100,
        }),
        agGridHelperService.getAvgAnnualMonthly1YrColDef(
          listingController,
          suppressDetails,
          {
            width: 80,
          }
        ),
        agGridHelperService.getAvgAnnualMonthly2YrColDef(listingController, {
          width: 80,
        }),
        agGridHelperService.getAvgAnnualMonthly3YrColDef(listingController, {
          width: 80,
        }),
        agGridHelperService.getAvgAnnualMonthly5YrColDef(listingController, {
          width: 80,
        }),
        agGridHelperService.getAvgAnnualMonthlyInceptionColDef(
          listingController,
          suppressDetails,
          {
            width: 80,
          }
        ),
      ],
    },
  ];
  return colGroupDefs;
}
